import {Injectable} from '@angular/core';
import {fetchUserAttributes} from '@aws-amplify/auth';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {EnvironmentConfigService} from '../../core/config/environment-config.service';
import {AuthenticationService} from '../authentication/authentication.service';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarketingConsentService {
  constructor(
    private httpClient: HttpClient,
    private environmentConfig: EnvironmentConfigService,
    private authenticationService: AuthenticationService
  ) {}

  async hasRecordedDecision(): Promise<boolean> {
    const attributes = await fetchUserAttributes();
    return this.isRecordedConsentValue((attributes as any)['custom:newsletter']);
  }

  async hasRecordedRealEstateAlertsDecision(): Promise<boolean> {
    const attributes = await fetchUserAttributes();
    return this.isRecordedConsentValue((attributes as any)['custom:real-estate-alerts']);
  }

  async saveDecision(newsletter: boolean): Promise<void> {
    try {
      await this.updatePreferences({newsletter});
    } catch (error) {
      console.error('Failed to save newsletter decision in Cognito attributes.', error);
      throw error;
    }
  }

  async saveRealEstateAlerts(enabled: boolean): Promise<void> {
    try {
      await this.updatePreferences({real_estate_alerts: enabled});
    } catch (error) {
      console.error('Failed to save real-estate-alerts in Cognito attributes.', error);
      throw error;
    }
  }

  private async updatePreferences(preferences: { newsletter?: boolean, real_estate_alerts?: boolean }): Promise<void> {
    const idToken = await this.authenticationService.getIdToken();
    if (typeof idToken !== 'string') {
      throw new Error('User is not authenticated');
    }

    const headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('Authorization', idToken);

    await firstValueFrom(
      this.httpClient.patch(
        `${this.environmentConfig.apiUrl}/user/preferences`,
        preferences,
        {headers}
      )
    );
  }

  private isRecordedConsentValue(value: string | undefined): boolean {
    return value === 'true' || value === 'false';
  }
}
